import "../styles/about.css";

export default function Rsr(props) {

    return (
        <div class="rsr-body">
            <h3>سامانه جامع باشگاه مشتریان کارگران کشور</h3>
            <p>
                مدیرمحترم مجموعه ورزشی و تفریحی کارگران
            </p>
            <p>
                ضمن خوشامد گویی ،
                 مفتخریم در کنار آن مجموعه محترم نسبت به ارائه امکانات نرم افزاری مورد نیاز جهت ارائه
                خدمات ورزشی و تفریحی وفرهنگی در قالب سامانه مذکور، به کارگران ارجمند نقشی داشته باشیم
                و امیدواریم با کمک هم دراین مسیرتوفیقات بیشتری کسب نمائیم .
            </p>
            <p>
                در این قسمت قصد داریم اطلاعات مورد
                نیاز را جهت تسهیم وجوه ناشی از حق عضویت  و رزرو اقامتگاه ها ، بر اساس ضوابط مشخص
                ، گردآوری و عملیات مالی را از طریق تسهیم از مبدا و در زمان تراکنش به انجام رسانیم .
            </p>
            <p>
                <ul>
                    <li>از  قسمت "شروع" وارد صفحه ورود شوید</li>
                    <li>شماره موبایل را وارد کنید</li>
                    <li>از قسمت فراموشی رمز ، رمز یکبار مصرف دریافت کنید</li>
                    <li>وارد صفحه ورود اطلاعات شوید</li>
                    <li>همه ی  فیلدها به دقت تکمیل کنید</li>
                    <li>روی دکمه "ثبت " کلیک کنید</li>
                    <li>در محله بعد مداراک را بارگزاری نمایید</li>
                </ul>
            </p>
            <p>پیشاپیش از حسن توجه و همکاری آن مجموعه محترم کمال تشکر را داریم</p>
            <p>
                <a className="btn-start" href="https://offplus.ir/RSR">شروع</a>
            </p>
        </div>
    );
}
